// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { formatText } = require('core/i18n').i18n;
// @constants
const PROVINCES = require('constants/provinces');
const { getTranslatedRoad } = require('constants/typeOfRoads');
// @Utilities
const { toCamelCase } = require('utilities/stringHelper');
const { formattedPhone, getFullName } = require('utilities/personalDataHelper');

const RetailLoanConfirmAddress = ({ immProfile, immAddress,
    email, className, phoneText }) => {

    const code = immProfile.getIn(['telefonoContacto', 'codigoPais']);
    const number = immProfile.getIn(['telefonoContacto', 'numero']);
    const phoneRaw = formattedPhone(code, number);
    const phone = formatText(phoneText, [phoneRaw]);

    const name = getFullName(immProfile, false);
    const typeOfRoads = toCamelCase(getTranslatedRoad(immAddress.get('typeOfRoads')) || '');
    const streetName = toCamelCase(immAddress.get('streetName'));
    const numberStreet = immAddress.get('numberStreet');
    const restOfAddress = toCamelCase(immAddress.get('restOfAddress'));
    const locality = toCamelCase(immAddress.get('locality'));
    const postalCode = immAddress.get('postalCode');
    const province = toCamelCase(PROVINCES[immAddress.get('province')] || '');

    const emailContainer = email ? (
        <span className={`${className}-item`}>
            {email}
        </span>
    ) : null;

    return (
        <div className={className}>
            <span className={`${className}-item`}>
                {toCamelCase(name)}
            </span>
            <span className={`${className}-item`}>
                {`${typeOfRoads} ${streetName} ${numberStreet}`}
            </span>
            <span className={`${className}-item`}>
                {`${restOfAddress} ${locality}`}
            </span>
            <span className={`${className}-item`}>
                {`${postalCode} ${province}`}
            </span>
            <span className={`${className}-item`}>
                {phone}
            </span>
            {emailContainer}
        </div>
    );
}

RetailLoanConfirmAddress.propTypes = {
    className: PropTypes.string,
    email: PropTypes.string,
    immProfile: PropTypes.object.isRequired,
    immAddress: PropTypes.object.isRequired,
    phoneText: PropTypes.string.isRequired
};

module.exports = RetailLoanConfirmAddress;
